import * as React from 'react';
import { observer } from 'mobx-react';
import ItemTileView, { ItemTileViewPropsBase } from './ItemTileView';

const styles = require('./FilePickerTileViewCommon.scss');
const classNames = require('classnames');

export interface FolderTileViewProps extends ItemTileViewPropsBase {
    childCount: number;
}

@observer
export default class FolderTileView extends React.Component<FolderTileViewProps, {}> {
    render() {
        return (
            <ItemTileView
                {...this.props as ItemTileViewPropsBase}
                className={styles.tileContainer}
                onSelectedClassName={styles.tileSelected}
                shouldShowTileOverlay={true}>
                <i
                    className={classNames(this.props.icon.large, styles.itemIcon)}
                    data-is-focusable={false}
                />
            </ItemTileView>
        );
    }
}
